<template>
  <div>
    <CodeEditor
      v-if="codingObjectReady"
      :mode="editMode ? 'edit' : 'add'"
      :is_blockly="is_blockly"
      :codingObject="codingObject"
      @ADD_NEW_ATTACHMENT="addNewAttachment"
      @REMOVE_ATTACHMENT="removeAttachment"
      @HANDLE_UPLOADED_ATTACHMENT_FILE="updateAttachmentFileId"
      @CAN_DOWNLOAD_CLICKED="handleCanDownloadClick"
      @CODING_OBJECT_EMITTED="handleCodingObject"
    />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import CodeEditor from "./CodeComponents/CodeEditor"

export default {
  components: {
    CodeEditor,
  },
  props: ["is_blockly", "editMode"],
  data() {
    return {
      codingObject: {
        provider_id: null,
        reading_time: null,
        files: [],
        attachments: [],
        created_on: "",
        time_allocated: 0,
        is_bonus: false,
        code_template_file_ids: {},
        id: "",
        qtags: [],
        placeholder_json: {
          data: [],
        },
        test_case_file_input_id: "",
        explain: null,
        content: "Content goes here",
        is_time_bound: true,
        is_required: false,
        type: this.is_blockly ? 8 : 6,
        item_cursor: 0,
        topics_questions: "[]",
        is_dependent_ids: "string",
        answers: "string",
        tries: 0,
        submission_cases: [],
        game_config_json: {},
        placeholder: null,
        slug: "",
        test_case_file_output_id: "",
        name: "",
        game_script_file_id: null,
        list: {},
        code_template_file_json: {
          data: [],
        },
        data: {
          hints: [],
          editorial: {},
        },
        points: 50,
        updated_on: "",
        author_id: "",
      },
      codingObjectReady: false,
    }
  },
  created() {
    if (this.editMode) {
      this.getQuestion()
    } else {
      this.codingObjectReady = true
    }
  },
  methods: {
    getQuestion() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.codingObject = res.data.data
        window.pageTitle = `Edit - ${this.codingObject.name}`
        this.codingObjectReady = true
      })
    },
    handleCodingObject(obj) {
      const url = this.editMode
        ? `${siteConfig.siteURL}questions/${this.$route.params.id}`
        : `${siteConfig.siteURL}questions/`
      const method = this.editMode ? "PUT" : "POST"

      this.axios({
        method,
        url,
        data: obj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          if (this.is_blockly) {
            this.$router.push("/blockly/")
          } else {
            this.$router.push("/coding/")
          }
        })
        .catch(err => {
          this.$noty.error(`Save failed: ${err}`)
        })
    },
    handleCanDownloadClick(data) {
      this.codingObject.files[data.itemIndex].can_download = data.checked
    },
    addNewAttachment() {
      this.codingObject.files.push({ name: "", can_download: false })
    },
    removeAttachment(index) {
      /* id is only present in uploaded files, so using index */
      this.codingObject.files.splice(index, 1)
    },
    updateAttachmentFileId(data) {
      this.codingObject.files[data.index].id = data.fileId
      this.codingObject.files[data.index].name = data.name
      this.codingObject.files[data.index].public_url = data.public_url
    },
  },
}
</script>
